import "jquery-mask-plugin"

document.addEventListener('sebDocumentReady', function() {

	const phoneMaskBehavior = function (val) {
  		return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
	};
	const phoneMaskOptions = {
  		onKeyPress: function(val, e, field, options) {
      		field.mask(phoneMaskBehavior.apply({}, arguments), options);
    	}
	};

  jQuery(".mask-phone").mask(phoneMaskBehavior, phoneMaskOptions)
  jQuery(".mask-cpf").mask("999.999.999-99")
  jQuery(".mask-birthdate").mask("99/99/9999")

  const $birthInput = $(".mask-birthdate");
    if ($birthInput.length) {
    $birthInput.each(function () {
        if (!$(this).prev(".birthdate-alert").length) {
        $(this).before('<div class="birthdate-alert" style="color:#c80b0b;font-size:13px;display:none;margin-bottom:4px;">Atenção: esse campo é referente à data de nascimento do aluno</div>');
        }
    });

    $birthInput.on("keyup blur", function () {
        const input = this;
        const $alert = $(input).prev(".birthdate-alert");
        setTimeout(() => {
        const value = $(input).val();

        let showAlert = false;

        const isValidFormat = /^\d{2}\/\d{2}\/\d{4}$/.test(value);
        if (!isValidFormat) {
            if (value.length === 10) {
            showAlert = true;
            }
        } else {
            const [day, month, year] = value.split("/").map(Number);

            if (day < 1 || day > 31) {
            showAlert = true;
            } else if (month < 1 || month > 12) {
            showAlert = true;
            } else if (year < 2000 || year > 2022) {
            showAlert = true;
            } else {
            const testDate = new Date(year, month - 1, day);
            if (
                testDate.getFullYear() !== year ||
                testDate.getMonth() !== month - 1 ||
                testDate.getDate() !== day
            ) {
                showAlert = true;
            }
            }
        }

        if (showAlert) {
            $alert.show();
        } else {
            $alert.hide();
        }
        }, 100);
    });
    } else {
        console.warn("[DEBUG] .mask-birthdate não encontrado no DOM");
    }

})
